<script lang="ts">
  import { clickoutside } from '@svelte-put/clickoutside';
  import { createFloatingActions } from 'svelte-floating-ui';
  import { offset as offsetMiddleware, autoPlacement } from 'svelte-floating-ui/dom';

  let clazz: string = '';
  export { clazz as class };
  export let offset = 6;

  const [floatingRef, floatingContent] = createFloatingActions({
    strategy: 'absolute',
    middleware: [offsetMiddleware(offset), autoPlacement()]
  });

  let showTooltip: boolean = false;

  function toggle(event: TouchEvent) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    showTooltip = !showTooltip;
  }
</script>

<div
  class={`d-inline-flex align-items-center ${clazz}`}
  on:mouseenter={() => (showTooltip = true)}
  on:mouseleave={() => (showTooltip = false)}
  on:touchstart={toggle}
  use:clickoutside={{}}
  on:clickoutside={() => (showTooltip = false)}
  use:floatingRef
  role="tooltip"
>
  <slot name="trigger" />
</div>

{#if showTooltip}
  <div class="bg-white shadow-sm border rounded-1 p-2 fs-7 w-75 mw-75 mt-10 tooltip-container" use:floatingContent>
    <slot />
  </div>
{/if}

<style>
  .tooltip-container {
    z-index: 100 !important;
    position: absolute;
    top: 100%;
    left: 50%;
  }

  @media (max-width: 700px) {
    .tooltip-container {
      left: 60%;
      transform: translateX(25%);
    }
  }
</style>
